export const DEFAULT_STRINGS = {
  actions: {
    clear: 'Clear',
    copy: 'Copy',
    copied: 'Copied!',
    close: 'Close',
    show: 'Show',
    hide: 'Hide',
    loading: 'Loading',
  },
  alert: {
    closeActionDescription: 'Close {{kind}} message',
  },
  avatar: {
    altText: 'Avatar for {{userName}}',
  },
  badge: {
    active: 'active',
    inactive: 'inactive',
    beta: 'beta',
    trialKind: '{{kind}} trial',
  },
  breadcrumbs: {
    label: 'Breadcrumb',
  },
  datePicker: {
    previousMonthButtonTooltip: 'Previous month',
    nextMonthButtonTooltip: 'Next month',
  },
  multiSelect: {
    emptyState: 'No other options available',
    noSearchTermMatch: 'No matches found for "{{searchTerm}}"',
  },
  notification: {
    closeActionDescription: 'Close {{kind}} {{name}}',
  },
  pagination: {
    itemsPerPage: 'Items per page',
    previousPageButtonTitle: 'Go to the previous page',
    previousPageButtonDisplayMessage: 'Prev',
    nextPageButtonTitle: 'Go to the next page',
    nextPageButtonDisplayMessage: 'Next',
    goToPage: 'Go to page {{page}}',
  },
  planBadge: {
    trialKind: '{{kind}} trial',
  },
  popover: {
    closeActionDescription: 'Close {{title}} popover',
  },
  table: {
    oneSelectedItem: '1 item selected',
    multipleSelectedItems: '{{numberRowsSelected}} items selected',
  },
  tag: {
    closeActionDescription: 'Close {{tagName}} tag',
  },
};

export type HotsauceStrings = typeof DEFAULT_STRINGS;
